<template>
  <!-- 条件分岐でh3だったらチェックボックス、nameだったら同じコンポーネントを呼ぶ -->
  <v-list-item>
    <v-list-item-title>
      <v-checkbox
        @click.stop="selectedTopic"
        :input-value="selected"
        :label="name"
        style="width: 600px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
      ></v-checkbox>
    </v-list-item-title>
    <v-list-item-icon>
      <a :href="url" target="_blank" rel="noopener noreferrer" style="text-decoration: none;"><v-icon>mdi-open-in-new</v-icon></a>
    </v-list-item-icon>
  </v-list-item>
</template>
<script>
export default {
    data () {
      return {
        selected: false,
        topic: {}
      }
    },
    name: 'ATagCheckBox',
    props: [
      'name',
      'url',
      'tagId'
    ],
    methods: {
      selectedTopic() {
        this.selected = !this.selected
        if (this.selected) {
          this.topic = {'name': this.name, 'url': this.url, 'id': this.tagId}
          this.$store.dispatch('bookmark/addTopicPart', this.topic)
        } else {
          this.$store.dispatch('bookmark/deleteTopicPart', this.tagId)
        }
      }
    }
  }
</script>
